<template>
  <div class="smallHeaderBox">
    <div style="width: 1200px;margin: 0 auto;overflow: hidden;">
      <div class="smallHeader">
        欢迎您来到科技金融公共服务平台！
      </div>
      <div class="backhome" v-if="user.phoneNumber">

        <a-dropdown>
          <template #overlay>
            <a-menu>
              <a-menu-item key="3">
                <a @click="onLogout">
                  <PoweroffOutlined /> 退出登录
                </a>
              </a-menu-item>
            </a-menu>
          </template>
          <a class="ant-dropdown-link" style="margin-left:20px;position:relative;padding:0 10px 0 10px" @click="islogin">
            <img style="position:absolute; left:-5px; top:2px" src="@/assets/img/login.png" alt=""> {{ user.phoneNumber }}
          </a>
        </a-dropdown>
      </div>
      <div class="backhome" v-else>
        <img src="@/assets/img/login.png" />
        <span @click="goMore('/login', 'user')" style="margin-left: 10px;">登录</span>
        <a-divider class="lineBox" type="vertical" />
        <span class="resigierBox" @click="this.$router.push('/register')">注册</span>
        <a-divider class="lineBox" type="vertical" />
      </div>
      <div class="backhome" style="margin-right:20px">
        <a-dropdown>
          <template #overlay>
            <a-menu>
              <a-menu-item @click="goMoreNotice('/Innovation/index', { type: '首页' })" key="2">
                创新创业
              </a-menu-item>
              <a-menu-item @click="goMoreNotice('/finance/index', { type: '首页' })" key="3">
                科技金融
              </a-menu-item>
              <a-menu-item @click="goMoreNotice('/knowledge/index', { type: '首页' })" key="4">
                知识产权
              </a-menu-item>
              <a-menu-item @click="goHttp('https://www.yqgxqsc.com/talent/#/home')" key="5">
                科技人才
              </a-menu-item>
              <a-menu-item @click="goMoreNotice('/achievements/index', { type: '首页' })" key="6">
                成果转化
              </a-menu-item>
            </a-menu>
          </template>
          <a class="ant-dropdown-link" @click="goMore('/')">
            <!-- <HomeOutlined />  -->
            首页
            <DownOutlined />
          </a>
        </a-dropdown>
      </div>
    </div>
  </div>
  <div class="headerBox">
    <div class="hearderContentBox">
      <div class="titleBox">
        <div class="logoBox">
          <img :src="getImg(all_logo)" alt="">
        </div>
        <span style="margin-left: 10px;">科技金融公共服务平台</span>
      </div>
      <!-- <div class="titleBox">科技金融服务子平台</div> -->
      <div class="rightBox">
        <div class="menuTopContent">
          <a-menu v-model:selectedKeys="current" mode="horizontal" @click="menuClick">
            <a-menu-item key="首页">
              首页
            </a-menu-item>
            <a-menu-item key="通知公告" title="通知公告">
              通知公告
            </a-menu-item>
            <a-menu-item key="科创贷" title="科创贷">
              科创贷
            </a-menu-item>
            <!-- <a-menu-item key="投资人" title="投资人">
              投资人
            </a-menu-item> -->
            <a-menu-item key="金融产品" title="金融产品">
              金融产品
            </a-menu-item>
            <a-menu-item key="金融机构" title="金融机构">
              金融机构
            </a-menu-item>
            <!-- <a-menu-item key="jrkt" title="金融课堂">
              金融课堂
            </a-menu-item>
            <a-menu-item key="jrxq" title="金融需求">
              金融需求
            </a-menu-item>
            <a-menu-item key="xmly" title="项目路演">
              项目路演
            </a-menu-item>
            <a-menu-item key="flfg" title="法律法规">
              法律法规
            </a-menu-item> -->
          </a-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {platformName} from "@/config/platformConfig";
import {file_service, login_mp} from "@/api/adminService";
import {ls} from "@/utils/util";

export default {
  name: "index",
  components: {
  },
  data() {
    return {
      user: {},
      platformName,
      current: ["首页"],
      formState: {
        user: null,
      },
      all_logo: '',
      formSearchBox: {
        city: null,
        company: null,
        project: null,
        demand: null
      },
    }
  },
  mounted() {
    if (ls.get('token') && ls.get("refresh_token")) {
      this.user.userName = this.$ls.get('userName')
      this.user.phoneNumber = this.$ls.get('phoneNumber')
    }
    this.current = this.$route.query.type || ["首页"]
    this.all_logo = this.$ls.get('all_logo');
  },
  methods: {
      goHttp(url) {
          window.open(url, '_bank')
      },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    islogin() {
      if (ls.get('token') && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else if (ls.get("roleCode").includes('serviceOrganization')) {
          this.goMore('/sys/innovation/organization/index');
        } else if (ls.get("roleCode").includes('investorManager')) {
          this.goMore('/finance/investorInformation');
        } else if (ls.get("roleCode").includes('investmentMechanism')) {
          this.goMore('/finance/investmentOrganizationInformation');
        } else if (ls.get("roleCode").includes('financialAdviser')) {
          this.goMore('/finance/financialAdvisorInformation');
        }else if (ls.get("roleCode").includes('bank')) {
                this.goMore('/finance/financingInstitutionInformation');
                }
        else {
          this.goMore('/sys/userInfo')
        }
      } else {
        this.goMore('/login', 'user')
      }
    },
    logout() {
      let self = this;

      self.$ls.clear();
      self.$store.commit('setMenuData', []);
      self.$router.replace('/');
      location.reload();

    },
    onLogout() {
      let self = this;
      self.$confirm({
        title: '确认要退出登录?',
        content: '',
        onOk() {
          self.postAction({
            url: login_mp.saveLog,
            params: { logAppCategoryEnum: "LOGOUT" }
          }).then(res => {
            console.log(res)
            self.getAction({
              url: login_mp.logout,
              params: { access_token: ls.get("token") || "" },
              isValid: false
            }).then(() => {
              self.$notification['success']({
                message: '退出成功',
                style: {
                  fontWeight: '600',
                },
              });
            })
          })


          setTimeout(() => {
            self.logout();
          }, 2000)
        },
        onCancel() {
        },
      });
    },
    goMore(url, key) {
      this.$router.push({
        path: url,
        query: { id: key, type: key }
      })
    },
    goMoreNotice(url, str) {
			this.$router.push({ path: url, query: { ...str } })
		},
    menuClick(e) {
      if (e.item.title == '投资人') {
        this.goMore('/finance/investor', '投资人')
      } else if (e.item.title == '科创贷') {
        this.goMore('/finance/ScienceTechnologyLoan', '科创贷')
      } else if (e.item.title == '金融机构') {
        this.goMore('/finance/invertorInstitution', '金融机构')
      } else if (e.item.title == '通知公告') {
        this.goMore('/finance/notice', '通知公告')
      } else if (e.item.title == '金融产品') {
        this.goMore('/finance/financialProduct', '金融产品')
      } else {
        this.goMore('/finance/index', '首页')
      }
    },
    backhome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="less">
@import "../css/main.less";

:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
  border-bottom: 3px solid #1890ff
}

:deep(.ant-menu-item-selected) {
  font-weight: 600;
}
</style>
